import { createFileRoute } from "@tanstack/react-router";
import ShowroomIntro from "lib/components/showroom2/pages/ShowroomIntro";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import { initializeShowroomWorker } from "lib/hooks/useShowroomWorkerBuilding";
import { useAppRouterParams } from "lib/routeHelpers";
import { useProducts } from "lib/security/client";
import { useUserContext } from "lib/state/UserContextProvider";
import { useEffect } from "react";

function Showroom2Intro() {
  const { builderId, planId, lotId } = useAppRouterParams();
  const { builder, builderLoading } = useUserContext();

  useProducts(builder, !!builderLoading, ["showroom"]);

  // Warm the shared showroom worker. In production the Vite preload plugin
  // already started it during HTML parse; this covers dev and SPA navigation.
  useEffect(() => {
    initializeShowroomWorker();
  }, []);

  const showroomKey = [builderId, planId, lotId].filter(Boolean).join("-") || undefined;

  return (
    <ShowroomProvider key={showroomKey}>
      <ShowroomIntro />
    </ShowroomProvider>
  );
}

export const Route = createFileRoute("/showroom/intro")({
  component: Showroom2Intro,
  staticData: { isPublicPage: true },
});
